export const yr2024 = {
    zelfstandigenaftrek: 3750,
    startersaftrek: 2123,
    mkbVrijstelling: 13.31,
    zvwBijdrage: { pct: 5.32, limit: 71628 },
    arbeidskorting: [
        { low: 0, high: 11491, pct: 8.425, addition: 0 },
        { low: 11491, high: 24821, pct: 31.433, addition: 968 },
        { low: 24821, high: 39958, pct: 2.471, addition: 5158 },
        { low: 39958, high: 124935, pct: -6.510, addition: 5532 },
        { low: 124935, high: 999999999, pct: 0, addition: 0 }
    ],
    belasting: [
        { low: 0, high: 75518, pct: 36.97, addition: 0 },
        { low: 75518, high: 999999999, pct: 49.50, addition: 27919 },
    ],
    heffingskorting: [
        { low: 0, high: 24813, pct: 0, addition: 3362 },
        { low: 24813, high: 75518, pct: -6.63, addition: 3362 },
        { low: 75518, high: 999999999, pct: 0, addition: 0 },
    ],
    inkomenhoogsteschaal: 75518,
    tarrifaanpassing: 0.1253,
}